import React, { useEffect, useMemo, useState } from "react";
import "./EVR-block-screen.styles.scss";

// import { getCompanyParams } from "../../services/sys-params-services";

import dayjs from "dayjs";
import CircleImage from "../../assets/circle.svg";

import {
  CheckCircleFilled,
  SearchOutlined,
  SyncOutlined,
} from "@ant-design/icons";

import { connect } from "react-redux";
import { useLocation, withRouter } from "react-router";

import { createStructuredSelector } from "reselect";

import {
  selectBranches,
  selectCrops,
  selectCurrentPage,
  selectDefaultParams,
  selectSelectedCrop,
  selectVarieties,
} from "../../redux/common/common.selectors";

// import { setBranchIndex } from "../../redux/common/common.actions";

import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  cancelAuction,
  editAuction,
  getExistingApproval,
  putExistingApproval,
  getMaterialCodes,
  getConditionCodes,
  checkVendorAvailability,
  getVendorUser,
  putEditVendorlist,
} from "../../services/auction-services";
import {
  getRebateMatrixService,
  getRebateService,
  getHubsService,
  getSlotIdsService,
} from "../../services/common-services";

import { FeatureCodes, dataConstants } from "../../constants/data-constants";
import { canUserAccess } from "../../utils/utils";

import {
  Table,
  Form,
  message,
  Checkbox,
  Popover,
  Modal,
  Button,
  Select,
  Input,
  Progress,
  Spin,
  Space,
  Col,
  Row,
  Typography,
  Flex,
  Switch,
} from "antd";

import CustomFilter from "../../components/custom-filter/custom-filter.component";
import {
  selectAuthData,
  selectUserData,
} from "../../redux/user/user.selectors";
import { Link } from "react-router-dom";
import Axios from "axios";
import ButtonGroup from "antd/lib/button/button-group";

const { Option } = Select;
const FileDownLoad = require("js-file-download");

const editDefault = {
  qty_rqd: undefined,
  rebate_matrix_id: undefined,
  auction_id: undefined,
};

const EVRBlockScreen: React.FC = (props: any) => {
  const {
    branches,
    varieties,
    selectedCropId,
    history,
    userData,
    crops,
    currentpage,
    defaultParams,
    authData,
  } = props;

  const [approvalsData, setApprovalsData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false); //true
  const [conditionCodes, setConditionCodesData] = useState<any>();
  const [filteredCrop, setFilteredCrop] = useState<any>([selectedCropId]);
  const [isSpinnerOnProgress, setIsSpinnerOnProgress] = useState(false);
  const location = useLocation();

  const [selectedDates, setSelectedDates] = useState([
    sessionStorage.getItem("startDateString") || dayjs().format("YYYY-MM-DD"),
    sessionStorage.getItem("endDateString") || dayjs().format("YYYY-MM-DD"),
  ]);
  const [filtersData, setFilters] = useState<any>();
  const [filtersDropdown, setFiltersDropdown] = useState<any>();
  const [filtersRole, setRoleFilters] = useState();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 20,
    total: 0,
    showSizeChanger: false,
  });

  const [searchText, setSearchText] = useState("");
  const { TextArea } = Input;

  /**
   * @component
   * @description Reusable component to display table header.
   * @property {string} title Title of header
   * @property {string} subtitle Subtitle of header
   * @memberof Approvals
   */
  const TableColumnHeader = (props: any) => {
    const { title, subtitle } = props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            fontWeight: 400,
            color: "white",
            fontSize: "14px",
            whiteSpace: "nowrap",
            textAlign: "left",
          }}
        >
          {title}
        </div>
        <div
          style={{
            color: "#cbdfff",
            fontSize: "11px",
            fontWeight: "normal",
            textAlign: "left",
          }}
        >
          {subtitle}
        </div>
      </div>
    );
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      // width: 110,
      filters: filtersData,
      filterSearch: true,
      sorter: (a, b) => a.name.localeCompare(b.name),
      ellipsis: true,
    },
    {
      title: "Phone Number",
      dataIndex: "contactNumber",
      key: "contact_number",
      // width: 100,
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      // width: 70,
      filters: filtersRole,
    },
    {
      title: "Vendor Code",
      dataIndex: "vendorCode",
      key: "vendor_code",
    },
    {
      title: "Account active/deactive",
      dataIndex: "Approve",
      key: "Approve",
      render: (value: number, row: any) => {
        return (
          <Switch
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            checked={row.isActive == 1}
            onChange={(e) => {
              onCheckBoxChange(row, e);
            }}
          />
        );
      },
    },
    {
      title: "Password block/unblock",
      dataIndex: "block",
      key: "block",
      render: (value: number, row: any) => {
        return (
          <Switch
            checkedChildren="Block"
            unCheckedChildren="Unblock"
            checked={row.blockedStatus == 0}
            disabled={row.blockedStatus == 0}
            onChange={(e) => {
              onCheckBlockChange(row, e);
            }}
          />
        );
      },
    },
    /* {
      title: "",
      dataIndex: "details",
      key: "details",
      render: (value: number, rowData: any) => {
        const data = {
          contactNumber: rowData.contactNumber,
          archives: true,
          existingTrader: true,
          PAN_no: rowData.PANNo,
        };
        return (
          <Link
            to={{
              pathname: `/details`,
              state: data,
            }}
          >
            {"View Details"}
          </Link>
        );
      },
    }, */
  ];

  // const handleSearch = (confirm: any) => {
  //   setTimeout(() => confirm(), 100);
  // };

  const getColumnSearchProps = (dataIndex: any) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: any) => {
      return (
        <Space direction="vertical">
          <Input.Search
            placeholder="Search"
            onSearch={(value) => {
              if (value.trim()) {
                setSelectedKeys([value.toUpperCase()]);
                confirm();
              } else clearFilters();
            }}
            allowClear
            enterButton
          />
        </Space>
      );
    },
    filterIcon: (filtered: any) => <SearchOutlined />,
    onFilter: (value: any, record: any) =>
      record[dataIndex].toString().includes(value),
    // onFilterDropdownVisibleChange: (visible: any) => {
    //   console.log("visible", visible);
    //   if (visible) {
    //     setTimeout(
    //       () => document.getElementById("search-input")?.onselect,
    //       100
    //     );
    //   }
    // },
  });
  const filteredData = (term: any) => {
    const filters = filtersData
      .flatMap((e: any) => {
        if (e.value.toLowerCase().includes(term.toLowerCase()))
          return {
            label: e.value,
            value: e.value,
          };
      })
      .filter((value) => value !== undefined);
    setFiltersDropdown(filters);
  };
  const getColumnFiltersProps = (dataIndex: any) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }: any) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={"Search"}
          onChange={(e) => {
            filteredData(e.target.value.toUpperCase());
          }}
          style={{ width: 180, marginBottom: 8, display: "flex" }}
          allowClear
        />
        <Space direction="vertical">
          <Checkbox.Group
            value={selectedKeys}
            onChange={(e) => {
              setSelectedKeys(e ? e : []);
            }}
            style={{ width: "180px", whiteSpace: "nowrap", overflow: "hidden" }}
          >
            <Row>
              {filtersDropdown &&
                filtersDropdown.map((e: any) => {
                  return (
                    <Col span={24} key={e.value}>
                      <Checkbox value={e.value}>
                        <Typography.Paragraph
                          style={{
                            display: "inline-block",
                            margin: 0,
                            verticalAlign: "bottom",
                            width: 130,
                          }}
                          ellipsis
                        >
                          {e.label}
                        </Typography.Paragraph>
                      </Checkbox>
                    </Col>
                  );
                })}
            </Row>
          </Checkbox.Group>
          <ButtonGroup>
            <Button type="primary" onClick={() => confirm()}>
              Search
            </Button>
            <Button
              danger
              onClick={() => clearFilters()}
              style={{ borderLeftColor: "inherit", left: "10%" }}
            >
              Reset
            </Button>
          </ButtonGroup>
        </Space>
      </div>
    ),
    onFilter: (value: any, record: any) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterSearch: true,
  });
  const getColumnSortProps = (dataIndex: any) => ({
    onFilter: (value: any, record: any) =>
      record[dataIndex].indexOf(value) === 0,
  });
  const columnsWithSearch = columns.map((col) => {
    if (col.dataIndex === "contactNumber" || col.dataIndex === "PANNo") {
      return {
        ...col,
        ...getColumnSearchProps(col.dataIndex),
      };
    } else if (col.dataIndex === "name") {
      return {
        ...col,
        ...getColumnFiltersProps(col.dataIndex),
      };
    } else {
      return {
        ...col,
        ...getColumnSortProps(col.dataIndex),
      };
    }
  });
  const filterData = useMemo(() => {
    if (!searchText) return approvalsData;

    return approvalsData.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchText.toLowerCase())
      )
    );
  }, [approvalsData, searchText]);
  const onCheckBoxChange = async (dataToPut: any, isactive: boolean) => {
    setIsLoading(true);
    const reqBody = {
      user_id: dataToPut.userId,
      is_active: isactive == true ? 1 : 0,
      // blocked_status: dataToPut.blockedStatus,
    };
    try {
      const response = await putEditVendorlist(reqBody);
      if (response.data.status) {
        message.success("Data Updated Successfully", 3);
        setApprovalsData([]);
        getApprovalData(filteredCrop, selectedDates[0], selectedDates[1]);
      } else {
        message.error(response.data.message, 3);
        // setApprovalsData([]);
      }
      setIsLoading(false);
    } catch (error) {
      message.error("Something went wrong :(", 3);
      console.log(error);
      setIsLoading(false);
    }
    setIsLoading(false);
  };
  const onCheckBlockChange = async (dataToPut: any, isBlock: boolean) => {
    setIsLoading(true);
    const reqBody = {
      user_id: dataToPut.userId,
      blocked_status: 1,
    };
    try {
      const response = await putEditVendorlist(reqBody);
      if (response.data.status) {
        message.success("Data Updated Successfully", 3);
        setApprovalsData([]);
        getApprovalData(filteredCrop, selectedDates[0], selectedDates[1]);
      } else {
        message.error(response.data.message, 3);
        // setApprovalsData([]);
      }
      setIsLoading(false);
    } catch (error) {
      message.error("Something went wrong :(", 3);
      console.log(error);
      setIsLoading(false);
    }
    setIsLoading(false);
  };

  const validate = async (dataToPut: any) => {
    if (
      dataToPut === null ||
      dataToPut === undefined ||
      dataToPut === "" ||
      dataToPut.length === 0
    ) {
      message.error("Enter valid details and select atleast one row.", 3);
      return false;
    } else {
      for (let i = 0; i < dataToPut.length; i++) {
        let eachRow = dataToPut[i];
        if (eachRow.approvalStatus === 6) {
          message.error("Please select Approval Status!", 3);
          setIsLoading(false);
          return false;
        } else if (
          eachRow.approvalStatus === 3 &&
          (eachRow.vendorCode === null ||
            eachRow.vendorCode === undefined ||
            eachRow.vendorCode.toString().length !== 9 ||
            eachRow.vendorCode.toString().trim() === "")
        ) {
          message.error("Please enter valid Vendor Code!", 3);
          setIsLoading(false);
          return false;
          // } else if (
          //   eachRow.approvalStatus === 3 &&
          //   eachRow.vendorCode.toString().trim() !== "" &&
          //   (await checkVendorIsDuplicate(eachRow.vendorCode))
          // ) {
          //   setIsLoading(false);
          //   return false;
        } else if (
          eachRow.remarks === null ||
          eachRow.remarks.trim() === "" ||
          eachRow.remarks === undefined
        ) {
          message.error("Please enter Remarks!", 3);
          setIsLoading(false);
          return false;
        }
      }
    }
    return true; // true
  };

  useEffect(() => {
    // onBranchChange();
    if (location.pathname.includes("/TN/vendorapprovals")) {
      getApprovalData(filteredCrop, selectedDates[0], selectedDates[1]);
    }
  }, [authData.access_token, currentpage, pagination.current]);

  const setApprovalStatus = async (
    statusId: number,
    contactNumber: number,
    userId: number
  ) => {
    const modifiedData = approvalsData.map((item: any) => {
      if (item.userId === userId && item.contactNumber === contactNumber) {
        return {
          ...item,
          approvalStatus: statusId,
          checked: true,
          // vendorCode: "",
        };
      } else {
        return item;
      }
    });
    setApprovalsData(modifiedData);
  };

  const setRoleData = async (
    roleId: number,
    contactNumber: number,
    userId: number
  ) => {
    const modifiedData = approvalsData.map((item: any) => {
      if (item.userId === userId && item.contactNumber === contactNumber) {
        return {
          ...item,
          role: roleId === 51 ? "TRADER" : "BROKER",
          role_id: roleId,
          checked: true,
        };
      } else {
        return item;
      }
    });
    setApprovalsData(modifiedData);
  };

  const setSelectedMaterialCode = async (
    materialId: any,
    varietyId: number,
    saudaId: number
  ) => {
    const modifiedData = approvalsData.map((item: any) => {
      if (item.saudhaId === saudaId && item.varietyId === varietyId) {
        return {
          ...item,
          materialId: materialId,
          checked: true,
        };
      } else {
        return item;
      }
    });
    setApprovalsData(modifiedData);
  };

  const setSelectedConditions = async (e: any, row: any, index: any) => {
    // console.log("Selected SAuda Data ------->", e.target.name, e.target.value, row, index);
    const modifiedData = approvalsData.map((item: any) => {
      if (
        item.saudhaId === row.saudhaId &&
        item.varietyId === row.varietyId &&
        e.target.value >= 0
      ) {
        conditionCodes[index].condition_value = Number(e.target.value);
        return {
          ...item,
          checked: true,
          conditionCodes,
        };
      } else {
        return item;
      }
    });
    setConditionCodesData(conditionCodes);
    setApprovalsData(modifiedData);
  };

  const setVendorCode = async (
    vendorCode: any,
    contactNumber: number,
    userId: number
  ) => {
    const modifiedData = approvalsData.map((item: any) => {
      if (
        item.userId === userId &&
        item.contactNumber === contactNumber &&
        !isNaN(vendorCode)
      ) {
        vendorCode = vendorCode.replace("", "");
        vendorCode = vendorCode.replaceAll(".", "");
        return {
          ...item,
          vendorCode: vendorCode,
        };
      } else {
        return item;
      }
    });
    setApprovalsData(modifiedData);
  };

  const setRemarks = async (
    remarks: any,
    contactNumber: number,
    userId: number
  ) => {
    const modifiedData = approvalsData.map((item: any) => {
      if (item.userId === userId && item.contactNumber === contactNumber) {
        return {
          ...item,
          remarks: remarks,
          // checked: true,
        };
      } else {
        return item;
      }
    });
    setApprovalsData(modifiedData);
  };

  const getApprovalData = async (
    cropIds: any[] | [],
    startDate: string,
    endDate: string
  ) => {
    try {
      setIsLoading(true);
      const params = {
        associated_branches: userData.user_territories,
        start_date: startDate,
        end_date: endDate,
        crops: cropIds.length === 0 ? crops.map((item) => item.id) : cropIds,
        page: pagination.current,
      };
      const response = await getVendorUser(params);
      if (response.data.status) {
        const data = response.data.data.map((item: any, index: any) => {
          return {
            key: index,
            sapBranch: item.sap_branch,
            contactNumber: item.contact_number,
            name: item.user_name,
            nameFirm: item.name_firm,
            blockedStatus: item.blocked_status,
            isActive: item.is_active,
            role: item.role,
            role_id: item.role_id,
            PANNo: item.PAN_no,
            rolesList: [
              { id: 51, val: "TRADER" },
              { id: 52, val: "BROKER" },
            ],
            userId: item.user_id,
            vendorCode: item.vendor_code,
          };
        });
        setPagination((prev) => ({
          ...prev,
          total: response.data.total, // total records from backend
        }));
        setApprovalsData(data);
        // const filtersNameFirm = Array.from(
        //   new Set(data.map((data) => data.nameFirm))
        // ).map((elements) => ({ text: elements, value: elements }));
        // const filtersRole = Array.from(
        //   new Set(approvalsData.map((data) => data.role))
        // ).map((elements) => ({ text: elements, value: elements }));
        const filters = data
          .map((e: any) => {
            return {
              label: e.name,
              value: e.name,
            };
          })
          .filter(
            (name, index, self) =>
              index ===
              self.findIndex(
                (r) => r.label === name.label && r.value === name.value
              )
          );
        const roleFilters = data
          .map((e: any) => {
            return {
              text: e.role,
              value: e.role,
            };
          })
          .filter(
            (role, index, self) =>
              index ===
              self.findIndex(
                (r) => r.text === role.text && r.value === role.value
              )
          );
        setFilters(filters);
        setFiltersDropdown(filters);
        setRoleFilters(roleFilters);
      } else {
        message.error("Something went wrong :(", 1);
        setApprovalsData([]);
      }
      setIsLoading(false);
    } catch (error) {
      message.error("Something went wrong :(", 1);
      console.log(error);
      setIsLoading(false);
    }
  };

  const onDateChange = (value: string | number | any, timeString: any) => {
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
    setSelectedDates(timeString);
    sessionStorage.setItem("startDateString", timeString[0]);
    sessionStorage.setItem("endDateString", timeString[1]);
    getApprovalData(filteredCrop, timeString[0], timeString[1]);
  };

  const onCropChange = (value: string | number | any, option: any) => {
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
    setFilteredCrop(value);
    getApprovalData(value, selectedDates[0], selectedDates[1]);
  };

  const onchange = (page) => {
    setPagination({
      current: page.current,
      pageSize: 20,
      total: 0, // total records from backend
      showSizeChanger: false,
    });
  };
  return (
    <div className="approval-screen">
      <Spin
        spinning={isSpinnerOnProgress}
        tip="Please wait while the file is being Downloaded..."
      >
        <Flex justify="space-between">
          <Space wrap>
            <Input.Search
              placeholder="Search..."
              allowClear
              onSearch={setSearchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: "15em" }}
              variant="outlined"
            />
            <CustomFilter
              type="multi-select"
              value={filteredCrop}
              options={crops}
              onChange={onCropChange}
              placeholder="Select Crop"
              head="Crop"
              className="status-filter"
              returnId
            />
            <CustomFilter
              type="range-picker"
              head="Date Range"
              startDate={dayjs(selectedDates[0])}
              endDate={dayjs(selectedDates[1])}
              disabledDate={true}
              onChange={onDateChange}
            />
          </Space>
          <Space>
            <Button
              className="refresh"
              icon={<SyncOutlined spin={isLoading} />}
              onClick={() =>
                getApprovalData(
                  filteredCrop,
                  selectedDates[0],
                  selectedDates[1]
                )
              }
            >
              Refresh
            </Button>
          </Space>
        </Flex>
        <div className="upcoming-table-container" style={{ paddingTop: 10 }}>
          <Table
            loading={isLoading}
            columns={columnsWithSearch}
            dataSource={filterData}
            pagination={pagination}
            onChange={onchange}
            size="small"
            // tableLayout="auto"
            // scroll={{ x: "max-content" }}
          />
        </div>
      </Spin>
    </div>
  );
};
// const mapDispatchToProps = (dispatch: Dispatch) => {
//   return {
//     setBranchIndex: (index: number) => dispatch(setBranchIndex(index)),
//   };
// };
const mapStateToProps = createStructuredSelector({
  userData: selectUserData,
  branches: selectBranches,
  crops: selectCrops,
  selectedCropId: selectSelectedCrop,
  varieties: selectVarieties,
  currentpage: selectCurrentPage,
  defaultParams: selectDefaultParams,
  authData: selectAuthData,
});

export default withRouter(connect(mapStateToProps)(EVRBlockScreen));
